<div class="layout-ParentDiv innerDiv UserRedemptionPage" [ngClass]="hide ? 'hideResponsiveTD  ' : 'showResponsiveTD '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Active User Report<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>
        </div>
      </div>

      <div class="mainDivBody">
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadActiveUserReports(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
          <div class="divider ">
            <hr>
          </div>
          <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
          </div>
          <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                    (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="country"></p-dropdown>
                </li>

                <!-- <li>
                <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                  (onChange)="getCities($event)" placeholder="Select State" optionLabel="name"
                  appendTo="body" [showClear]="true" [(ngModel)]="state"></p-dropdown>
              </li> -->
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                    (onChange)="getCities($event)" placeholder="Select State" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="state"></p-dropdown>
                </li>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                    (onChange)="onCityChange($event)" placeholder="Select City"
                    optionLabel="name" optionValue="name" appendTo="body" [showClear]="true"
                    [(ngModel)]="cityName"></p-dropdown>
                </li>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                    (onChange)="loadActiveUserReports(lastTableLazyLoadEvent)" placeholder="Select Sport"
                    optionLabel="name" optionValue="name" appendTo="body" [showClear]="true"
                    [(ngModel)]="sportName"></p-dropdown>
                </li>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                    (onChange)="loadActiveUserReports(lastTableLazyLoadEvent)" placeholder="Select Academy"
                    optionLabel="name" optionValue="id" appendTo="body" [showClear]="true"
                    [(ngModel)]="academyId"></p-dropdown>
                </li>

              </ul>
            </div>
          </div>

        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="activeUserReportsData" [autoLayout]="true" [paginator]="true"
              [rows]="10" [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadActiveUserReports($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="mobileNumber">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="mobileNumber"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="email" class="emailTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Email Id <p-sortIcon field="email"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="username" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> User Name <p-sortIcon
                        field="username"></p-sortIcon>
                    </div>
                  </th>
                  <th class="genderTD" pSortableColumn="gender">
                    <div class="p-d-flex p-jc-between p-ai-center"> Gender <p-sortIcon
                        field="gender"></p-sortIcon>
                    </div>
                  </th>
                  <th class="cityTD" pSortableColumn="city">
                    <div class="p-d-flex p-jc-between p-ai-center"> City <p-sortIcon
                        field="city"></p-sortIcon>
                    </div>
                  </th>
                  <th class="stateTD" pSortableColumn="state"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> State <p-sortIcon field="state"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="tournamentParticipated">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament Participated <p-sortIcon
                        field="tournamentParticipated"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="courtBooked"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Court Booked <p-sortIcon
                        field="courtBooked"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="findPartnerUsed"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Find A Partner (Used) <p-sortIcon
                        field="findPartnerUsed"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="academyEnrolled"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Enrolled <p-sortIcon
                        field="academyEnrolled"></p-sortIcon>
                    </div>
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" rowspan="1" colspan="1"
                    style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                      [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                  </th>

                  <th class="emailTD" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'email', 'contains')"
                      [value]="dt.filters['email'] ? dt.filters['email'].value : ''" />
                  </th>
                  <th class="userNameTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'username', 'contains')"
                      [value]="dt.filters['username'] ? dt.filters['username'].value : ''" />
                  </th>
                  <th class="genderTD" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gender', 'contains')"
                      [value]="dt.filters['gender'] ? dt.filters['gender'].value : ''" />
                  </th>
                  <th class="cityTD" style="left: 0px">
                  </th>
                  <th class="stateTD" style="left: 0px">
                  </th>
                  <th class="registrationDateTD">
                  </th>
                  <th class="registrationDateTD"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                  </th>
                  <th class="registrationDateTD"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                  </th>
                  <th class="registrationDateTD"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-activeUserReportsData>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="mobileNumberTD">
                    <div class="textOverFlow1" pTooltip="{{activeUserReportsData?.mobileNumber}}"
                      tooltipPosition="bottom">
                      {{activeUserReportsData?.mobileNumber}}
                    </div>
                  </td>

                  <td class="emailTD">
                    {{activeUserReportsData?.email}}
                  </td>
                  <td class="userNameTD">
                    {{ activeUserReportsData?.username }}
                  </td>
                  <td class="genderTD">
                    {{ activeUserReportsData?.gender }}
                  </td>
                  <td class="cityTD">
                    {{ activeUserReportsData?.city }}
                  </td>
                  <td class="stateTD">
                    {{ activeUserReportsData?.state }}
                  </td>
                  <td class="registrationDateTD activityDetailsTD">
                    {{ activeUserReportsData?.tournamentParticipated }}
                  </td>
                  <td class="registrationDateTD activityDetailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ activeUserReportsData?.courtBooked }}
                  </td>
                  <td class="registrationDateTD activityDetailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ activeUserReportsData?.findPartnerUsed }}
                  </td>
                  <td class="registrationDateTD activityDetailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ activeUserReportsData?.academyEnrolled }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">Active User Report list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
